import React from "react";
import notify from "devextreme/ui/notify";
import Form, { SimpleItem, GroupItem, Label } from "devextreme-react/form";
import "devextreme-react/text-area";
import UserInfo from "../../UserInfo";
import {
  inserirOuAtualizar,
  criarDiatDs,
  criarContribuinteDs,
  criarReceitasDs,
  criarSituacaoDividaDs,
  criarImovelDs,
} from "../../DataSources";
import { Format } from "devextreme-react/number-box";
import sysCodigoDescricao from "../../components/sysCodigoDescricao";
import ContribuinteBox from "../contribuintes/ContribuinteBox";
import ImovelBox from "../imovel/ImovelBox";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import { ScrollView, Button } from "devextreme-react";
import uiInfo from "../../ui-info";
import ShowError from "../../AppServices";
import responsive_box from "devextreme/ui/responsive_box";
import api from "../../api-axios";
import { showReportDirect } from "../../showReport";

const template = {
  id: undefined,
  prefeituraId: undefined,
  codigoDeOrigem: "**",
  valorOriginal: undefined,
  vencimentoOriginal: undefined,
  contribuinteId: undefined,
  coresponsaveisIds: "",
  receitaId: undefined,
  multaTI: undefined,
  jurosTI: undefined,
  correcaoTI: undefined,
  historico: "",
  processo: "",
  acordao: "",
  fundamento: "",
  parcela: "-",
  ano: undefined,
  popupContribuinteVisivel: false,
  popupImovelVisivel: false,
  gerarCda: true,
  dadosTermoManuais: 1
};

export default class DiatFormNovo extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
    template.prefeituraId = UserInfo.getPrefeitura();
    this.diatDs = criarDiatDs();

    this.ok = this.ok.bind(this);
    this.cancel = this.cancel.bind(this);
    this.saidaProgramada = false;

    //
    /* Funções do contribuinte
     */
    this.contribuinteDs = criarContribuinteDs();
    this.setContribuinteId = this.setContribuinteId.bind(this);
    this.pesquisarContribuinte = this.pesquisarContribuinte.bind(this);
    this.onContribuinteSelecionadoPesquisa =
      this.onContribuinteSelecionadoPesquisa.bind(this);
    this.contribuinteBoxRef = React.createRef();
    this.renderContribuinte = sysCodigoDescricao(
      () => this.state.contribuinteId,
      this.setContribuinteId,
      () => this.state._uiNome,
      this.pesquisarContribuinte
    );
    //
    /* Fim das funções do contribuinte
     */

    //
    /* Funções do imovel
     */
    this.imovelDs = criarImovelDs();
    this.setImovelId = this.setImovelId.bind(this);
    this.pesquisarImovel = this.pesquisarImovel.bind(this);
    this.onImovelSelecionadoPesquisa =
      this.onImovelSelecionadoPesquisa.bind(this);
    this.imovelBoxRef = React.createRef();
    this.renderImovel = sysCodigoDescricao(
      () => this.state.imovelId,
      this.setImovelId,
      () => this.state._uiImovelNome,
      this.pesquisarImovel
    );
    //
    /* Fim das funções do imovel
     */

    this.opcoesTrueFalse = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: true, descricao: "SIM" },
        { id: false, descricao: "NÃO" }
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.opcoesCalculo = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: 1, descricao: "NAO TRANSFERIR ENCARGOS" },
        { id: 2, descricao: "CALCULO AUTOMÁTICO" },
        { id: 3, descricao: "CALCULO MANUAL" }
      ],
      valueExpr: "id",
      displayExpr: "descricao",
      onValueChanged: e => {
        if (e.event) {
          this.setState({ dadosTermoManuais: e.value });
        }

      }
    };

    this.escolherReceita = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      dataSource: criarReceitasDs(),
      valueExpr: "id",
      displayExpr: "descricao",
      placeholder: "[ click para selecionar a receita ]"
    };

    this.escolherSituacao = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      dataSource: criarSituacaoDividaDs(),
      valueExpr: "id",
      displayExpr: "nome",
      readOnly: true,
      placeholder: " "
    };
  }

  componentDidMount() {
    if (this.props.match.params.id !== undefined) {
      this.diatDs
        .byKey(this.props.match.params.id)
        .then((data) => {
          if (!data) {
            notify("Diat não encontrado.", "error");
            this.props.history.push("/diat");
          }
          this.setState(data);
        })
        .catch((error) => {
          ShowError(error.response.data);
          notify(error, "error", 2000);
          this.props.history.goBack();
        });
    }

    if (this.props.match.params.id === undefined) {
      const dataCorrente = new Date();
      this.setState({ ...template, ano: dataCorrente.getFullYear(), dataDeTransferencia: dataCorrente });
    }
  }

  setContribuinteId(data) {
    this.contribuinteDs
      .load({ filter: [["sequencial", "=", data.value]] })
      .then((result) => {
        if (result.length !== 0) {
          if (result[0] === undefined) {
            this.setState({ _uiNome: "" });
          } else {
            this.setState({
              _uiNome: result[0].nome,
              contribuinteId: data.value,
              popupContribuinteVisivel: false,
            });
          }
        } else {
          this.setState({ _uiNome: "" });
        }
      })
      .catch((_) => {
        this.setState({ _uiNome: "<<ERRO>>" });
      });
  }

  onContribuinteSelecionadoPesquisa(e) {
    this.setContribuinteId({ value: e.row.data.sequencial.toString() });
  }

  pesquisarContribuinte() {
    this.contribuinteBoxRef.current.limparFiltro();
    this.setState({ popupContribuinteVisivel: true });
  }

  setImovelId(data) {
    this.imovelDs
      .load({ filter: [["sequencial", "=", data.value]] })
      .then((result) => {
        if (result.length !== 0) {
          if (result[0] === undefined) {
            this.setState({ _uiImovelNome: "" });
          } else {
            this.setState({
              _uiImovelNome: result[0].enderecoSemCidade,
              imovelId: data.value,
              popupImovelVisivel: false,
            });
          }
        } else {
          this.setState({ _uiImovelNome: "" });
        }
      })
      .catch((_) => {
        this.setState({ _uiImovelNome: "<<ERRO>>" });
      });
  }

  onImovelSelecionadoPesquisa(e) {
    this.setImovelId({ value: e.row.data.sequencial.toString() });
  }

  pesquisarImovel() {
    this.imovelBoxRef.current.limparFiltro();
    this.setState({ popupImovelVisivel: true });
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <Form formData={this.state} colCount={1} labelLocation="left">
            <GroupItem
              colSpan={4}
              colCount={3}
              caption="Informações de Dívida Ativa Novo"
            >
              <SimpleItem colSpan={3} component={this.renderContribuinte}>
                <Label text="Responsável" />
              </SimpleItem>
              <SimpleItem dataField={"coresponsaveisIds"}
                editorType={"dxTextBox"}
                editorOptions={{ maxLength: 30 }}
                colSpan={3}>
                <Label text="Có-Responsável(eis)" />
              </SimpleItem>
              <SimpleItem component={this.renderImovel} colSpan={3}>
                <Label text="Imóvel" />
              </SimpleItem>

              <SimpleItem
                dataField={"receitaId"}
                editorType={"dxLookup"}
                editorOptions={this.escolherReceita}
                colSpan={3}
              >
                <Label text="Receita" />
              </SimpleItem>

              <SimpleItem
                dataField={"historico"}
                editorType={"dxTextArea"}
                editorOptions={{ height: "80px" }}
                colSpan={3}
              >
                <Label text="Histórico" />
              </SimpleItem>
            </GroupItem>

            <GroupItem caption="Termo de Inscrição" colSpan={1} colCount={3}>
              <SimpleItem
                dataField={"dadosTermoManuais"}
                editorType={"dxSelectBox"}
                editorOptions={this.opcoesCalculo}
                helpText={"SIM para copiar os dados do termo para os cálculos manuais de dívida ativa e utilizá-lo inclusive na CDA."}
                colSpan={3}
              >
                <Label text="Cálculo de Encargos" />
              </SimpleItem>
              <SimpleItem
                editorType={"dxNumberBox"}
                editorOptions={{
                  format: uiInfo.formatoNumerico.n2,
                  step: 0,
                }}
                cssClass="box-n2"
                dataField={"valorOriginal"}>
                <Label text="Valor Original" />
              </SimpleItem>
              <SimpleItem
                dataField={"vencimentoOriginal"}
                editorType={"dxDateBox"}
                editorOptions={{ width: "100%", useMaskBehavior: true }}
              >
                <Label text="Vencimento Original" />
              </SimpleItem>
              <SimpleItem dataField={"ano"} editorType={"dxNumberBox"}>
                <Label text="Exercício Original" />
              </SimpleItem>

              <SimpleItem
                editorType={"dxNumberBox"}
                editorOptions={{
                  format: uiInfo.formatoNumerico.n2,
                  step: 0,
                }}
                cssClass="box-n2"
                dataField={"multaTI"}
                visible={this.state.dadosTermoManuais == 3}>

                <Label text="Multa" />
              </SimpleItem>
              <SimpleItem
                editorType={"dxNumberBox"}
                editorOptions={{
                  format: uiInfo.formatoNumerico.n2,
                  step: 0,
                }}
                cssClass="box-n2"
                dataField={"jurosTI"}
                visible={this.state.dadosTermoManuais == 3}>
                <Label text="Juros" />
              </SimpleItem>
              <SimpleItem
                editorType={"dxNumberBox"}
                editorOptions={{
                  format: uiInfo.formatoNumerico.n2,
                  step: 0,
                }}
                cssClass="box-n2"
                dataField={"correcaoTI"}
                visible={this.state.dadosTermoManuais == 3}>
                <Label text="Correção" />
              </SimpleItem>



            </GroupItem>
            <GroupItem colCount={1} colSpan={3} caption="Outras Informações">
              <SimpleItem dataField={"codigoDeOrigem"} editorType={"dxTextBox"}>
                <Label text="Código de Origem" />
              </SimpleItem>
              <SimpleItem dataField={"parcela"} editorType={"dxTextBox"}>
                <Label text="Parcela" />
              </SimpleItem>
              <SimpleItem dataField={"processo"} editorType={"dxTextBox"}>
                <Label text="Processo" />
              </SimpleItem>
              <SimpleItem dataField={"acordao"} editorType={"dxTextBox"}>
                <Label text="Acórdão" />
              </SimpleItem>
              <SimpleItem
                editorType={"dxTextArea"}
                editorOptions={{ height: "100px", wrap: false }}
                dataField={"fundamento"}
                colSpan={2}>
                <Label text="Fundamento" />
              </SimpleItem>

            </GroupItem>
            <GroupItem colCount={1} colSpan={3} caption="Outras ações">
              <SimpleItem
                dataField={"gerarCda"}
                editorType={"dxSelectBox"}
                editorOptions={this.opcoesTrueFalse}
                helpText={"SIM para após o cadastro emitir automaticamente a CDA."}
              >
                <Label text="Gerar CDA" />
              </SimpleItem>

            </GroupItem>
          </Form>
          <br />
          <br />
          <div
            style={{
              marginTop: "10px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div style={{ display: "inline-block" }}>
              <Button
                width={150}
                text="Salvar"
                type="success"
                onClick={this.ok}
              />
            </div>
            <div style={{ display: "inline-block", marginLeft: "10px" }}>
              <Button
                width={150}
                text="Cancelar"
                type="default"
                onClick={this.cancel}
              />
            </div>
          </div>
        </div>
        <Popup
          visible={this.state.popupContribuinteVisivel}
          onHiding={() => this.setState({ popupContribuinteVisivel: false })}
          dragEnabled={false}
          closeOnOutsideClick={false}
          showCloseButton={false}
          showTitle={true}
          width={"90%"}
          height={"90%"}
          title="Pesquisar Contribuinte"
        >
          <ScrollView showScrollbar={"always"}>
            <ContribuinteBox
              onSelecionado={this.onContribuinteSelecionadoPesquisa}
              ref={this.contribuinteBoxRef}
            />
          </ScrollView>
          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              text: "Fechar",
              type: "default",
              width: 150,
              onClick: () => this.setState({ popupContribuinteVisivel: false }),
            }}
          ></ToolbarItem>
        </Popup>
        <Popup
          visible={this.state.popupImovelVisivel}
          onHiding={() => this.setState({ popupImovelVisivel: false })}
          dragEnabled={false}
          closeOnOutsideClick={false}
          showCloseButton={false}
          showTitle={true}
          width={"90%"}
          height={"90%"}
          title="Pesquisar Contribuinte"
        >
          <ScrollView showScrollbar={"always"}>
            <ImovelBox
              onSelecionado={this.onImovelSelecionadoPesquisa}
              ref={this.imovelBoxRef}
            />
          </ScrollView>
          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              text: "Fechar",
              type: "default",
              width: 150,
              onClick: () => this.setState({ popupImovelVisivel: false }),
            }}
          ></ToolbarItem>
        </Popup>
      </React.Fragment>
    );
  }

  ok() {
    const entidade = this.state;
    entidade.prefeituraId = UserInfo.getPrefeitura();

    api
      .post("/diat", entidade)
      .then(resp => {
        console.log("resposta inscricao", resp);

        if (resp.data.sucesso) {
          notify("Dívida ativa cadastrado com sucesso.", "success");

          if (resp.data.cdaId != undefined) {
            showReportDirect(resp.data.cdaReport);
            this.props.history.push("/cda");
          }
          else {
            this.props.history.push("/acompanhardiat");
          }
        }
        else {
          ShowError(resp.data.erros);
        }
      });
  }

  cancel() {
    notify("Operação cancelada", "warning");
    this.props.history.goBack();
  }
}
